/* global Shopify */
const origFetch = window.fetch;
window.fetch = function ()
{
    var origArguments = arguments;
    var urlRequest = origArguments[0];
    return new Promise(function (resolve, reject)
    {
        origFetch.apply(this, origArguments).then(function (response)
        {
            if ([
                'https://upsells.boldapps.net/v2/' + Shopify.shop + '/get_checkout_offer',
                'https://upsells.boldapps.net/v2/' + Shopify.shop + '/validate_checkout_offer'
            ].indexOf(urlRequest) > -1)
            {
                response.json().then(function (data)
                {
                    if (urlRequest === 'https://upsells.boldapps.net/v2/' + Shopify.shop + '/get_checkout_offer')
                    {
                        data = ox.upsells.processData(data);
                    }
                    else if (urlRequest === 'https://upsells.boldapps.net/v2/' + Shopify.shop + '/validate_checkout_offer')
                    {
                        if (data.offer_exist)
                        {
                            data = ox.upsells.validateCheckoutOffer(data);
                        }
                        ox.upsells.enableCheckoutButton();
                    }
                    response.json = function ()
                    {
                        return new Promise(function (r, j)
                        {
                            r(data);
                        });
                    };
                    resolve(response);
                }).catch(function(e)
                {
                    ox.upsells.enableCheckoutButton();
                });
            }
            else
            {
                resolve(response);
            }
        }).catch(function (error)
        {
            reject(error);
        });
    });
};